import { Progress } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import styles from './style.module.scss';
import ArrImg from '@/assets/images/mobile/simulation/arrow.png';
import { Display } from '../Display/Display';
//专门针对案例仿真的进度环写的组件
//因为使用svg实现的 所以移动端的不在mobile文件夹，避免打包成rem导致样式错乱
const strokeColor = {
    '0%': 'rgba(1, 39, 255, 1)',
    '100%': 'rgba(104, 194, 255, 1)'
};
const CaseProgressCircle = ({ percent = 0, onclickArrow }) => {
    return (
        <div className={styles.box}>
            <Display show={percent < 100}>
                <Progress showInfo={false} type="circle" percent={percent} trailColor="transparent" strokeColor={'#3b70ff'}></Progress>
            </Display>
            <div data-value={percent} className={styles.arrowIconWrap} onClick={onclickArrow}>
                <img src={ArrImg} alt="" />
            </div>
        </div>
    );
};
export default CaseProgressCircle;
